import { ReactNode } from 'react';
import styled from 'styled-components';

import { Position } from '@sorare/core/src/__generated__/globalTypes';
import { DefaultPosition } from '@sorare/core/src/assets/icons/DefaultPosition';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM } from '@sorare/core/src/atoms/typography';
import useScreenSize from '@sorare/core/src/hooks/device/useScreenSize';

import { PositionDetails } from '../PositionDetails';

const Root = styled(Vertical).attrs({ gap: 0, center: true })`
  justify-content: stretch;
`;

type Props = {
  appearanceName: string;
  shortName: Nullable<string>;
  displayName: Nullable<ReactNode>;
  positions?: Position[];
  icon?: ReactNode;
};

const CardPlaceholderInfo = ({
  appearanceName,
  shortName,
  displayName,
  positions,
  icon,
}: Props) => {
  const { up: isDesktopOrAbove } = useScreenSize('desktop');
  return (
    <Root>
      {icon || (
        <span title={appearanceName}>
          <DefaultPosition />
        </span>
      )}
      <BodyM>
        <strong>{isDesktopOrAbove ? displayName : shortName}</strong>
      </BodyM>
      <PositionDetails positions={positions} />
    </Root>
  );
};

export default CardPlaceholderInfo;
